import { createAction } from '@ngrx/store';

import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import { CustomDotCmsContentlet } from '../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentDepth } from '../../services/dot-cms-resource/dot-cms-resource.service';

export const loadDotCmsContentlet = createAction(
  '[DOTCMS Contentlet Internal] load dotcms Contentlet',
  payload<{
    identifier: string;
    depth?: DotCmsContentDepth;
  }>()
);

export const loadDotCmsContentletSuccess = createAction(
  '[DOTCMS Contentlet API] load dotcms contentlet success',
  payload<{
    contentlet: CustomDotCmsContentlet;
  }>()
);

export const loadDotCmsContentletFail = createAction(
  '[DOTCMS Contentlet API] load dotcms contentlet Fail',
  httpError()
);

export const loadDotCmsContentletsSuccess = createAction(
  '[DOTCMS Contentlet API] load dotcms contentlets success',
  payload<{
    contentlets: CustomDotCmsContentlet[];
  }>()
);

export const loadDotCmsContentletsFail = createAction('[DOTCMS API] load dotcms contentlets page fail', httpError());
